import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MaterialModule } from 'src/app/core/material.module';
import { NotificationService } from 'src/app/core/services/notification.service';

import { AbilityService } from 'src/app/core/services/ability/ability.service';
import { UserService } from 'src/app/core/services/user.service';
import { AnnotationsService } from '../../services/annotations.service';
import { AnnotatioTypeCommentInfoComponent } from './annotatio-type-comment-info/annotatio-type-comment-info.component';
import { AnnotatioTypeMainInfoComponent } from './annotatio-type-main-info/annotatio-type-main-info.component';
import { trackFeatureUse } from 'src/app/core/analytics';

@Component({
  selector: 'annotations-details',
  templateUrl: './annotations-details.component.html',
  styleUrls: ['./annotations-details.component.scss'],
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    AnnotatioTypeMainInfoComponent,
    AnnotatioTypeCommentInfoComponent,
  ],
})
export class AnnotationsDetailsComponent implements OnInit {
  name;
  data;
  change: boolean = false;
  color: string = '';
  maiInfoFormData: any;
  addCommentData: any;
  mainFormValid = true;
  public annotationForm = new FormGroup({
    color: new FormControl('', [Validators.required]),
    eventType: new FormControl('', [
      Validators.required,
      Validators.minLength(1),
      Validators.maxLength(50),
    ]),
    label: new FormControl('', [
      Validators.required,
      Validators.minLength(1),
      Validators.maxLength(50),
    ]),
    comments: new FormControl('', [
      Validators.minLength(1),
      Validators.maxLength(256),
    ]),
    hotKeys: new FormControl('', [
      Validators.minLength(1),
      Validators.maxLength(20),
    ]),
  });

  constructor(
    public ability: AbilityService,
    private annotationsService: AnnotationsService,
    public route: ActivatedRoute,
    public userService: UserService,
    private notificationService: NotificationService,
    public router: Router
  ) {}

  ngOnInit(): void {
    if (this.route.snapshot.queryParams['id']) {
      this.annotationsService
        .getAnnotationById(this.route.snapshot.queryParams['id'])
        .subscribe((res) => {
          this.name = res.name;
          this.data = res;
          this.change = true;
        });
    }
  }

  public onChangeColor(color: string): void {
    this.color = color;
    this.annotationForm.patchValue({ color });
  }

  save() {
    trackFeatureUse('annotations', 'settings_saved');
    this.annotationsService.eventEmitter.emit('sendData');
    var dataToSave = {
      ...this.addCommentData,
      ...this.maiInfoFormData,
    };

    if (this.mainFormValid) {
      if (this.route.snapshot.queryParams['id']) {
        this.annotationsService
          .updateAnnotation(dataToSave, this.route.snapshot.queryParams['id'])
          .subscribe({
            complete: () => {
              this.notificationService.success(
                'Annotation Updated Successfully'
              );
              this.navigateToList();
            },
            error: (error) => {
              this.notificationService.error('Cannot Created');
            },
          });
      } else {
        this.annotationsService.create(dataToSave).subscribe({
          complete: () => {
            this.notificationService.success('Annotation Created Successfully');
            this.navigateToList();
          },
          error: (error) => {
            this.notificationService.error('Cannot Created');
          },
        });
      }
    } else {
      this.mainFormValid = true;
      this.notificationService.error('Please fill all required fields');
      return;
    }
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }
  getmainForminfo(data) {
    this.mainFormValid = true;
    if (data) {
      this.maiInfoFormData = data;
    } else {
      this.mainFormValid = false;
    }
  }
  getCommentFormInfo(data) {
    this.addCommentData = data;
  }
  public navigateToList() {
    this.router.navigate(['settings/annotations']);
  }
}
